import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", null, "No tags yet.")
], -1)

import { Tag } from '@/models/tag';
import TagListItem from './TagListItem.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    tags: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createBlock(_component_DataView, {
    value: __props.tags,
    layout: 'list',
    class: "data-view"
  }, {
    list: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TagListItem, {
          tag: slotProps.data
        }, null, 8, ["tag"])
      ])
    ]),
    empty: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})